<template> 
  <div ref="fotoPortadaRef" class="fotoportada-container"> 
    <div class="overlay"> 
       
      <!-- SECCIÓN SUPERIOR: Gráficos (círculo, muñeca, moño) --> 
      <div class="top-graphics-wrapper"> 
        <img 
          ref="circuloRef" 
          src="@/assets/circuuu.png" 
          alt="Círculo de Rosas" 
          class="circulo-img" 
        > 
        <img 
          ref="quinceaneraRef" 
          src="@/assets/quincee.png" 
          alt="Quinceañera" 
          class="quinceanera-img" 
        > 
        <img 
          ref="monoRef" 
          src="@/assets/mariposa.png" 
          alt="Moño Rojo" 
          class="mono-img" 
        > 
      </div> 
 
      
      <!-- SECCIÓN PADRINOS --> 
      <div ref="madrinasRef" class="corte-seccion"> 
        <h3 class="corte-titulo">Mis Padrinos</h3> 
        <p class="madrinas-mensaje"> 
        </p> 
        <ul class="corte-lista"> 
          <li>Vanessa Carpintero</li> 
          <li>Finess Yvonne Mercado</li> 
          <li>Selen Ledezma</li> 
          <li>Natali</li> 
          <li>Adrian Rivas</li> 
          <li>John</li> 
          <li>Betza Avalos</li> 
          <li>Arissa Aguilera</li> 
          <li>Sergio Aguilera</li> 
          <li>Marisa</li> 
          <li>Aldrin Gonzalez</li> 
          <li>Jesus</li> 
          <li>Erika Zavala</li> 
        </ul> 
      </div> 
 
    
 
      <!-- 🦋 MARIPOSAS --> 
      
    </div> 
  </div> 
</template> 
 
<script>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'InvitacionQuinceanera',

  setup() {
    const fotoPortadaRef = ref(null)
    const circuloRef = ref(null)
    const quinceaneraRef = ref(null)
    const monoRef = ref(null)
    const chambelanesRef = ref(null)
    const madrinasRef = ref(null)

    let ctx

    onMounted(() => {

      ctx = gsap.context(() => {

        /* ==========================================
           ANIMACIÓN INICIAL DE PORTADA
           ========================================== */

        gsap.from(fotoPortadaRef.value, {
          opacity: 0,
          y: 80,
          duration: 1.4,
          ease: 'power3.out'
        })


        /* ==========================================
           GRÁFICOS SUPERIORES
           ========================================== */

        const tl = gsap.timeline({ delay: 0.8 })

        tl.fromTo(
          circuloRef.value,
          {
            opacity: 0,
            y: -150,
            scale: 1.8,
            filter: 'blur(15px)'
          },
          {
            opacity: 1,
            y: 0,
            scale: 1,
            filter: 'blur(0px)',
            duration: 1.8,
            ease: 'power4.out'
          },
          0
        )

        tl.from(
          quinceaneraRef.value,
          {
            opacity: 0,
            y: 50,
            duration: 1.5,
            ease: 'power3.out'
          },
          0.8
        )

        tl.from(
          monoRef.value,
          {
            opacity: 0,
            scale: 0,
            duration: 1.2,
            ease: 'back.out(1.8)'
          },
          1.2
        )


        /* ==========================================
           MIS PADRINOS
           SOLO ANIMA CUANDO ENTRA AL VIEWPORT
           ========================================== */

        gsap.set(madrinasRef.value, {
          opacity: 0,
          y: 60
        })

        ScrollTrigger.create({
          trigger: madrinasRef.value,

          // Empieza cuando la sección entra en pantalla
          start: 'top 85%',

          // Una sola vez
          once: true,

          onEnter: () => {
            gsap.to(madrinasRef.value, {
              opacity: 1,
              y: 0,
              duration: 1.2,
              ease: 'power3.out'
            })
          }
        })

      }, fotoPortadaRef.value)

    })

    onBeforeUnmount(() => {
      if (ctx) {
        ctx.revert()
      }
    })

    return {
      fotoPortadaRef,
      circuloRef,
      quinceaneraRef,
      monoRef,
      chambelanesRef,
      madrinasRef
    }
  }
}
</script>
 
<style scoped> 
/* ========================================== 
   1. ESTILOS BASE Y CONTENEDORES 
   ========================================== */ 
.fotoportada-container { 
  position: relative; 
  width: 100%; 
  min-height: 100vh; 
  overflow: visible; 
  background-color: #fff; 
  margin-top: -60px; 
  background-repeat: no-repeat; 
  background-position: center bottom; 
  z-index: 1; 
} 
 
.overlay { 
  position: relative; 
  width: 100%; 
  display: flex; 
  flex-direction: column; 
  align-items: center; 
  justify-content: flex-start; 
  padding: 40px 20px 80px 20px; 
  z-index: 2; 
} 
 
/* ========================================== 
   2. GRÁFICOS SUPERIORES 
   ========================================== */ 
.top-graphics-wrapper { 
  position: relative; 
  width: 100%; 
  max-width: 500px; 
  display: flex; 
  flex-direction: column; 
  align-items: center; 
  margin-bottom: 20px; 
  z-index: 3; 
} 
 
.circulo-img { 
  width: 100%; 
  max-width: 550px; 
  height: auto; 
  position: relative; 
  z-index: 1; 
} 
 
.quinceanera-img { 
  width: 90%; 
  max-width: 260px; 
  height: auto; 
  position: absolute; 
  top: 55%; 
  left: 50%; 
  transform: translate(-50%, -50%); 
  z-index: 0; 
} 
 
.mono-img { 
  width: 80%; 
  max-width: 150px; 
  height: auto; 
  margin-top: -96px; 
  position: relative; 
  z-index: 3; 
} 
 
/* ========================================== 
   3. TEXTOS Y CONTENIDO CENTRAL 
   ========================================== */ 
.centered-content { 
  text-align: center; 
  color: #8C6F4D; 
  display: flex; 
  flex-direction: column; 
  align-items: center; 
  gap: 8px; 
  margin-top: -40px; 
  z-index: 4; 
} 
 
.lets-honor-text { 
  font-family: 'Playfair Display', serif; 
  font-size: 14px; 
  font-weight: 600; 
  letter-spacing: 2px; 
  text-transform: uppercase; 
  color: #B28F60; 
} 
 
.quinceanera-title { 
  font-family: 'Playfair Display', serif; 
  font-size: 28px; 
  font-weight: 700; 
  letter-spacing: 3px; 
  text-transform: uppercase; 
  color: #B28F60; 
  margin-top: -5px; 
} 
 
.nombre-principal { 
  font-family: 'CynthiaJuneJF', serif; 
  font-size: 85px; 
  font-weight: 500; 
  line-height: 1; 
  color: #9C1B2C; 
  margin: 15px 0; 
} 
 
/* ========================================== 
   4. SECCIÓN FECHA 
   ========================================== */ 
.fecha-container { 
  display: flex; 
  flex-direction: column; 
  align-items: center; 
  gap: 12px; 
  color: #B28F60; 
  margin-bottom: 25px; 
} 
 
.fecha-linea-superior { 
  display: flex; 
  align-items: center; 
  gap: 25px; 
} 
 
.fecha-mes-texto { 
  font-family: 'Playfair Display', serif; 
  font-size: 14px; 
  font-weight: 600; 
  letter-spacing: 1.5px; 
  text-transform: uppercase; 
} 
 
.fecha-dia-numero { 
  font-family: 'CynthiaJuneJF', serif; 
  font-size: 55px; 
  font-weight: 500; 
  line-height: 1; 
  color: #9C1B2C; 
} 
 
.fecha-anio-numero { 
  font-family: 'CynthiaJuneJF', serif; 
  font-size: 28px; 
  font-weight: 500; 
  line-height: 1; 
  color: #9C1B2C; 
} 
 
/* ========================================== 
   5. BOTÓN GOOGLE MAPS 
   ========================================== */ 
.google-maps-btn { 
  display: inline-block; 
  padding: 10px 25px; 
  background-color: white; 
  border: 2px solid #D8C7B0; 
  border-radius: 25px; 
  color: #9C1B2C; 
  text-transform: uppercase; 
  font-family: 'Playfair Display', serif; 
  font-size: 12px; 
  font-weight: 700; 
  letter-spacing: 1.5px; 
  text-decoration: none; 
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1); 
  cursor: pointer; 
  transition: all 0.3s ease; 
} 
 
.google-maps-btn:hover { 
  background-color: #F8F4EE; 
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15); 
} 
 
/* ========================================== 
   6. SECCIONES CORTE (CHAMBELANES Y MADRINAS) 
   ========================================== */ 
.corte-seccion { 
  width: 100%; 
  max-width: 450px; 
  margin-top: 40px; 
  text-align: center; 
  z-index: 4; 
} 
 
.corte-titulo { 
  font-family: 'Playfair Display', serif; 
  font-size: 22px; 
  font-weight: 700; 
  letter-spacing: 2px; 
  text-transform: uppercase; 
  color: #9b9a99; 
  margin-bottom: 12px; 
} 
 
.madrinas-mensaje { 
  font-family: 'Playfair Display', serif; 
  font-size: 14px; 
  font-style: italic; 
  color: #9b9a99; 
  margin-bottom: 18px; 
  padding: 0 15px; 
  line-height: 1.4; 
} 
 
.corte-lista { 
  list-style: none; 
  padding: 0; 
  margin: 0; 
  display: flex; 
  flex-direction: column; 
  gap: 8px; 
} 
 
.corte-lista li { 
  font-family: 'Playfair Display', serif; 
  font-size: 17px !important; 
  font-weight: 600; 
  color: #5999d2; 
  letter-spacing: 1px; 
} 
 
/* ========================================== 
   7. 🎭 MÁSCARA LADO IZQUIERDO 
   ========================================== */ 
.mascara-left-container { 
  position: absolute; 
  top: 5%; 
  left: 10%; 
  pointer-events: none; 
  z-index: 5; 
} 
 
.mascara-img-left { 
  width: 210px; 
  height: auto; 
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.15)); 
  transform: rotate(-15deg); 
} 
 
@keyframes flotacionSuave { 
  0%, 100% { 
    transform: translateY(0px) rotate(-15deg); 
  } 
  50% { 
    transform: translateY(-8px) rotate(-12deg); 
  } 
} 
 
.flotacion-suave { 
  animation: flotacionSuave 3s infinite ease-in-out; 
} 
 
/* ========================================== 
   8. 🦋 MARIPOSAS Y ANIMACIÓN 
   ========================================== */ 
.butterflies-container { 
  position: absolute; 
  inset: 0; 
  width: 100%; 
  height: 100%; 
  pointer-events: none; 
  z-index: 100; 
  margin-top: 40px; 
  margin-right: 40px !important; 
  overflow: hidden; 
  perspective: 1000px; 
} 
 
.mariposa-img { 
  position: absolute; 
  width: 120px !important; 
  height: auto; 
  opacity: 1 !important; 
  will-change: transform; 
  transform-origin: center bottom; 
} 
 
@keyframes vueloSuave { 
  0%, 100% { 
    transform: translateY(0px) scaleX(1); 
  } 
  50% { 
    transform: translateY(-3px) scaleX(0.75); 
  } 
} 
 
.vuelo-suave { 
  animation: vueloSuave 0.6s infinite ease-in-out; 
} 
</style>